<!-- eslint-disable @intlify/vue-i18n/no-missing-keys -->
<template>
  <div
    v-for="product in store.bumProductList"
    :key="product.priceId"
    class="flex flex-col items-start self-stretch rounded-lg border-dashed border-gray-200"
  >
    <div
      class="flex items-center justify-between gap-2 self-stretch rounded-t-lg bg-[#fdfcbe] px-3 py-3"
    >
      <div class="flex items-center gap-2 self-stretch">
        <img
          :src="ArrowFlashIcon"
          :alt="t('common.products.productImageAlt')"
          class="rounded-lg"
          loading="lazy"
        />
        <input
          :id="product.productId"
          :name="product._id"
          :value="product._id"
          type="checkbox"
        />
        <UITextSmMedium
          :style="{
            color: '#090',
          }"
          >{{ product.headline }}</UITextSmMedium
        >
      </div>
    </div>
    <div
      v-if="
        product.enableImage ||
        product.otoText?.length > 0 ||
        product.otoHeadline?.length > 0
      "
      class="flex flex-col items-start gap-2 self-stretch p-4"
    >
      <p
        v-if="product.otoText?.length > 0 || product.otoHeadline?.length > 0"
        class="flex items-start gap-2 self-stretch"
      >
        <span
          v-if="product.otoHeadline?.length > 0"
          class="font-bold text-[#c30] underline"
          >{{ product.otoHeadline }}</span
        >
        <span v-if="product.otoText?.length > 0">{{ product.otoText }}</span>
      </p>
      <img
        v-if="
          product.enableImage &&
          (product.uploadedImage?.length > 0 || product.image?.length > 0)
        "
        :src="product.uploadedImage || product.image"
        :alt="t('common.products.productImageAlt')"
        class="h-auto max-w-full"
        loading="lazy"
      />
      <div
        v-else-if="product.enableImage"
        class="h-20 w-20 rounded-lg bg-[lightgray]"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ArrowFlashIcon from "@/assets/gif/arrow-flash-small.webp";
import { useAppStore } from "@/store/app";
import { UITextSmMedium } from "@gohighlevel/ghl-ui";
import { useI18n } from "vue-i18n";

const store = useAppStore();
const { t } = useI18n();
</script>

<style scoped>
.border-bottom {
  border-bottom: 2px solid #eaecf0;
  border-style: solid;
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>
